import { Trash2, Zap, Scissors, FileCheck } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { thumbUrl } from "@/lib/api";

export const ExtrasTags = ({ line }) => {
  const { t } = useLang();
  const tags = [
    line.rush && { k: "rush", icon: Zap, label: t("common.rush") },
    line.cut && { k: "cut", icon: Scissors, label: t("common.cut") },
    line.file_check && { k: "check", icon: FileCheck, label: t("common.check") },
  ].filter(Boolean);
  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map(({ k, icon: Icon, label }) => (
        <span key={k} className="inline-flex items-center gap-1 rounded bg-white/5 px-2 py-0.5 text-xs font-bold text-slate-300"><Icon className="h-3 w-3" /> {label}</span>
      ))}
    </div>
  );
};

export const CartLine = ({ line, index, onQty, onRemove }) => {
  const { t, money, num } = useLang();
  return (
    <div className="panel flex gap-4 p-4" data-testid={`cart-line-${index}`}>
      <div className="checker grid h-24 w-24 shrink-0 place-items-center overflow-hidden rounded p-1.5">
        <img src={thumbUrl(line.upload_id)} alt="" className="max-h-full max-w-full object-contain" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="flex items-center gap-2 font-extrabold">
              <span className={`rounded px-1.5 py-0.5 text-[10px] ${line.print_type === "dtf" ? "bg-ruby" : "bg-cap"}`}>{t(`common.${line.print_type}`)}</span>
              <span className="font-mono-num">{num(line.width)}" × {num(line.height)}"</span>
            </p>
            <p className="truncate text-xs text-slate-500">{line.upload?.original_filename}</p>
          </div>
          <p className="font-mono-num font-bold text-gold" data-testid={`cart-line-total-${index}`}>{money(line.line_total)}</p>
        </div>
        <ExtrasTags line={line} />
        <div className="mt-auto flex items-center justify-between gap-3">
          {onQty ? (
            <label className="flex items-center gap-2 text-xs font-bold text-slate-400">
              {t("cart.qty")}
              <input type="number" min="1" value={line.quantity} onChange={(e) => onQty(Math.max(1, parseInt(e.target.value, 10) || 1))} className="field w-24 py-1.5 font-mono-num" data-testid={`cart-qty-${index}`} />
              <span className="font-mono-num">{money(line.unit_price, 3)} {t("cart.each")}</span>
            </label>
          ) : (
            <span className="text-xs font-bold text-slate-400">{t("cart.qty")} {line.quantity}</span>
          )}
          {onRemove && (
            <button onClick={onRemove} className="text-slate-500 transition-colors hover:text-ruby" data-testid={`cart-remove-${index}`} aria-label={t("cart.remove")}>
              <Trash2 className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
